import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { ChipMember } from '@pkg/components/Sections/Profile/Chips/ChipMember';

import { StyledSearchListItemSpacer, StyledSearchListItemWrapper } from './styles';

interface UserItemProps {
    primaryYat: string;
    twitter?: string;
    focused?: boolean;
    onFocused?: (link: string) => void;
}

export function UserItem({ primaryYat, twitter, focused, onFocused }: UserItemProps) {
    const link = `/${primaryYat}`;

    useEffect(() => {
        focused && onFocused?.(link);
    }, [focused, link, onFocused]);

    return (
        <Link to={link}>
            <StyledSearchListItemWrapper $focused={focused}>
                <ChipMember yat={primaryYat} size="smaller" twitter={twitter ?? undefined} />
                <StyledSearchListItemSpacer />
            </StyledSearchListItemWrapper>
        </Link>
    );
}
